import React from "react";

/**
 * NecklaceButton Component - Toggle button for necklace visualization
 * 
 * @param {boolean} isVisible - Whether necklace is currently visible
 * @param {Function} onToggle - Callback to toggle necklace visibility
 */
const NecklaceButton = ({ isVisible, onToggle }) => {
  return (
    <button 
      className={`necklace-button ${isVisible ? 'active' : ''}`}
      onClick={onToggle}
      title={isVisible ? 'Hide necklace visualization' : 'Show necklace (Lyndon word)'}
    >
      ⭕
    </button>
  );
};

export default NecklaceButton;